import { __decorate } from "tslib";
import { Component, Vue, Watch, } from "vue-property-decorator";
import { State, Action } from "vuex-class";
let SysContentHeader = class SysContentHeader extends Vue {
    constructor() {
        super(...arguments);
        this.noticeList = [];
        this.animate = false;
        this.intNum = 0;
        this.timer = 0;
    }
    getVisible() {
        this.Stop();
        this.initData();
    }
    scrollUp() {
        this.Stop();
        this.intNum = setInterval(() => {
            this.animate = true; // 向上滚动的时候需要添加css3过渡动画
            setTimeout(() => {
                this.noticeList.push(this.noticeList[0]); // 将数组的第一个元素添加到数组的
                this.noticeList.shift(); //删除数组的第一个元素
                this.animate = false;
            }, 500);
            if (this.noticeList.length <= 1) {
                this.Stop();
            }
        }, 10000);
    }
    Stop() {
        clearInterval(this.intNum);
        clearTimeout(this.intNum);
    }
    Up() {
        if (this.noticeList.length > 1) {
            this.scrollUp();
        }
    }
    newClick(item) {
        this["$common"].save("/oper-manage/message/platform-notice/details", item);
        if (this.$route.path == "/oper-manage/message/platform-notice/details") {
            this.$router.push("/blank-page");
        }
        else {
            this.$router.push("/oper-manage/message/platform-notice/details");
        }
    }
    initData() {
        this.noticeList = JSON.parse(JSON.stringify(this.sysMsg.noticeUnreadList));
        if (this.noticeList.length > 1) {
            this.scrollUp();
        }
        else {
            this.Stop();
        }
    }
    mounted() {
        this.getNoticerSummary();
    }
    deactivated() {
        clearInterval(this.intNum);
        clearInterval(this.timer);
    }
};
__decorate([
    State("sys")
], SysContentHeader.prototype, "sys", void 0);
__decorate([
    State("sysMsg")
], SysContentHeader.prototype, "sysMsg", void 0);
__decorate([
    Action("getNoticerSummary")
], SysContentHeader.prototype, "getNoticerSummary", void 0);
__decorate([
    Watch("sysMsg.noticeCount")
], SysContentHeader.prototype, "getVisible", null);
SysContentHeader = __decorate([
    Component
], SysContentHeader);
export default SysContentHeader;
